import { object, string } from 'yup';

export default object({
  extraDamageDescription: string()
    .required()
    .label('Beschrijven')
});
